(() => {
	function init() {
		$('[data-lightbox]').each(function() {
			$(this).magnificPopup({
				type: 'image'
			});
		});

		$('[data-lightbox-gallery]').each(function() {
			$(this).magnificPopup({
				delegate: 'a:not(.slick-cloned)',
				type: 'image',
				gallery: {
					enabled: true
				}
			});
		});

		$('[data-lightbox-slider]').each(function() {
			$(this).magnificPopup({
				delegate: '.slick-slide:not(.slick-cloned) a',
				type: 'image',
				gallery: {
					enabled: true
				}
			});
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});
})();
